import { Component, Input } from '@angular/core';
import { ExportService } from '../../services/export.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-export-btn',
  templateUrl: './export-btn.component.html',
  styleUrls: ['./export-btn.component.css']
})
export class ExportBtnComponent {
  @Input() selectedRows: any[] = [];
  @Input() allColumns: any[] = [];
  @Input() fileName: any;
  @Input() allRecords: any[] = []
  @Input() exportApi:any;
  @Input() exportParams: any;
  @Input() includeLineItems: boolean = false;
  constructor(private exportService: ExportService) {}

  openExportDialog(): void {
    // if (!this.selectedRows || this.selectedRows.length === 0) {
    //   alert('Please select at least one record.');
    //   return;
    // }

    this.exportService.openExportDialog(this.selectedRows, this.allColumns, this.fileName, this.allRecords, this.exportApi, this.exportParams).subscribe((result) => {
      if (result) {
        console.log('Export confirmed!');
      } else {
        console.log('Export cancelled.');
      }
    });
  }
}
